import { render } from "./BaseSearchInput.vue?vue&type=template&id=1d549000&ts=true"
import script from "./BaseSearchInput.vue?vue&type=script&lang=ts"
export * from "./BaseSearchInput.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__